import { render, staticRenderFns } from "./CampaignLayout.vue?vue&type=template&id=677f29c0&scoped=true"
import script from "./CampaignLayout.vue?vue&type=script&lang=js"
export * from "./CampaignLayout.vue?vue&type=script&lang=js"
import style0 from "./CampaignLayout.vue?vue&type=style&index=0&id=677f29c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677f29c0",
  null
  
)

export default component.exports